import { CampaignCommonProps } from "../types";
import { NamedSwitch } from "../../../ui/layout/molecules/NamedSwitch";
import { CampaignBooleanKeys, TextCampaignInfluencersKeys } from "../../types";
import { controlledInputTitles } from "../../constants";

export const RenderSwitchableSettings = (
  key: CampaignBooleanKeys | TextCampaignInfluencersKeys,
  { currentValues, updateBodyField }: CampaignCommonProps,
) => {
  return (
    <NamedSwitch
      key={key}
      title={controlledInputTitles[key]}
      value={!!currentValues[key]}
      onChange={(value) => updateBodyField({ [key]: value })}
      styleVariant="newPage"
    />
  );
};
